// extracted by mini-css-extract-plugin
export default {"page":"Dashboard_page__V2jTL","container":"Dashboard_container__zIEUH","open":"Dashboard_open__qk0HF"};